import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';
import { Label } from '@olist/united';

export default styled(Label)`
  margin: ${tokens.spacing[300]} 0;
`;
